var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPasswordHidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.902 15.08A9.125 9.125 0 0110 16.5C5.507 16.5 1.768 13.267.984 9a9.152 9.152 0 012.783-5.055L1.16 1.34 2.34.16l16.498 16.5-1.179 1.18-2.757-2.76zM4.946 5.126A7.47 7.47 0 002.686 9a7.504 7.504 0 0011 4.865l-1.69-1.69a3.75 3.75 0 01-5.171-5.172l-1.88-1.878zm5.816 5.815L8.06 8.238a2.083 2.083 0 002.7 2.701l.002.001zm6.577 1.887l-1.192-1.192A7.445 7.445 0 0017.314 9 7.502 7.502 0 007.96 3.448L6.645 2.133A9.157 9.157 0 0110 1.5c4.493 0 8.232 3.233 9.016 7.5a9.122 9.122 0 01-1.677 3.827zm-7.57-7.57a3.75 3.75 0 013.974 3.974L9.77 5.257z",
    fill: "#575757"
  })));
}

export default SvgPasswordHidden;